import React from 'react';
import PropTypes from 'prop-types';
import RichText from '../rich-text';

import { Heading } from './styles';
import { RichTextPropTypes } from '../../prop-types';

const StepTitle = ({ title = '', text }) => (
  <>
    <legend>
      <Heading>{title}</Heading>
    </legend>
    <RichText richText={text} />
  </>
);

StepTitle.propTypes = {
  title: PropTypes.string,
  text: RichTextPropTypes,
};

export default StepTitle;
